import styled from 'styled-components';
import { motion } from 'framer-motion';
import { theme } from '@/styles/theme';

interface CardProps {
  elevated?: boolean;
  interactive?: boolean;
  bordered?: boolean;
}

export const Card = styled(motion.div)<CardProps>`
  background: ${theme.colors.neutral.white};
  border-radius: ${theme.borderRadius.xl};
  padding: ${theme.spacing[6]};
  box-shadow: ${({ elevated }) => (elevated ? theme.shadows.lg : theme.shadows.base)};
  border: ${({ bordered }) => (bordered ? `1px solid ${theme.colors.secondary.ivory}` : 'none')};
  transition: all ${theme.transitions.base};

  ${({ interactive }) =>
    interactive &&
    `
    cursor: pointer;

    &:hover {
      transform: translateY(-4px);
      box-shadow: ${theme.shadows.xl};
    }
  `}

  @media (max-width: ${theme.breakpoints.md}) {
    padding: ${theme.spacing[4]};
  }
`;

export const CardHeader = styled.div`
  margin-bottom: ${theme.spacing[4]};
`;

export const CardTitle = styled.h3`
  font-size: ${theme.fontSizes['2xl']};
  color: ${theme.colors.primary.navy};
  margin-bottom: ${theme.spacing[2]};
`;

export const CardSubtitle = styled.p`
  font-size: ${theme.fontSizes.sm};
  color: ${theme.colors.neutral.gray};
`;

export const CardContent = styled.div`
  line-height: ${theme.lineHeights.relaxed};
  color: ${theme.colors.neutral.darkGray};
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const CardFooter = styled.div`
  margin-top: ${theme.spacing[4]};
  padding-top: ${theme.spacing[4]};
  border-top: 1px solid ${theme.colors.secondary.ivory};
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: ${theme.spacing[3]};
`;

export const CardImage = styled.img`
  width: 100%;
  height: 200px;
  object-fit: cover;
  border-radius: ${theme.borderRadius.lg};
  margin-bottom: ${theme.spacing[4]};
`;
